import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Cta} from '../../blocks';
import {IS_MOBILE} from "../../constants/environment";
import './styles.css';

class EstimateLink extends PureComponent {
  
  static propTypes = {
    label: PropTypes.string,
    targetBlank: PropTypes.bool,
    color: PropTypes.string,
    buttonStyle: PropTypes.string,
    linkType: PropTypes.string,
    carId: PropTypes.string,
    carTypeCode: PropTypes.string,
    gradeCode: PropTypes.string,
    drive: PropTypes.string,
    mission: PropTypes.string,
    engine: PropTypes.string,
    ecode: PropTypes.string,
    soptions: PropTypes.array,
    direct: PropTypes.string,
  };
  
  static defaultProps = {
    label: null,
    targetBlank: null,
    color: null,
    buttonStyle: null,
    linkType: null,
    carId: null,
    carTypeCode: null,
    gradeCode: null,
    drive: null,
    mission: null,
    engine: null,
    ecode: null,
    soptions: null,
    direct: null,
  };
  
  constructor(props) {
    super();
    this.props = props;
    this.state = {
      isMounted: false,
    }
  }
  
  componentDidMount() {
    this.setState({
      isMounted: true,
    });
  };
  
  componentWillUnmount() {
    this.setState({
      isMounted: false,
    });
  }
  
  render() {
    let href = '/purchase/estimate/';
    // let href = 'https://ssl.mazda.co.jp/purchase/estimate/';
    // if (this.state.isMounted) {
    //   href = IS_MOBILE ? 'https://ssl.mazda.co.jp/sp/purchase/estimate/' : 'https://ssl.mazda.co.jp/purchase/estimate/';
    // }
    // CarId
    if (this.props.carId && this.props.carId !== '') {
      href = href + '?car_id=' + this.props.carId;
      // href = href + 'edit.html?car_id=' + this.props.carId;
    }
    // CarTypeCode
    if (this.props.carTypeCode && this.props.carTypeCode !== '') {
      href = href + '&car_type_code=' + this.props.carTypeCode;
    }
    // GradeCode
    if (this.props.gradeCode && this.props.gradeCode !== '') {
      href = href + '&grade_code=' + this.props.gradeCode;
    }
    // エクステリアカラー
    // if (this.props.ecode && this.props.ecode !== '') {
    //   href = href + '&ecode=' + this.props.ecode;
    // }
    // ドライブ
    if (this.props.drive && this.props.drive !== '') {
      href = href + '&drive=' + this.props.drive;
    }
    // エンジン
    if (this.props.engine && this.props.engine !== '') {
      href = href + '&engine=' + this.props.engine;
    }
    // ミッション
    if (this.props.mission && this.props.mission !== '') {
      href = href + '&mission=' + this.props.mission;
    }
    // ショップオプション
    if (this.props.soptions && 1 <= this.props.soptions.length) {
      let str = '';
      this.props.soptions.map((soption) => {
        str = str + soption + ':'
      });
      if (str !== '') {
        href = href + '&soptions=' + str.slice(0, -1);
      }
    }
    // 遷移画面
    if (this.props.direct && this.props.direct  !== '') {
      if (this.props.direct === 'Grade') {
        href = href + '&direct=id_contents_grade';
      } else if (this.props.direct === 'Color-And-Sheet') {
        href = href + '&direct=id_contents_color';
      } else if (this.props.direct === 'Maker-Set-Option') {
        href = href + '&direct=id_contents_maker';
      } else if (this.props.direct === 'Shop-Option') {
        href = href + '&direct=id_contents_shop';
      } else if (this.props.direct === 'Result') {
        href = href + '&direct=id_contents_estimate';
      }
    }
  
    return (
      <div className="EstimateLink">
        <Cta
          {...{
            ctaType: 'Free',
            href: href,
            text: this.props.label || '見積りシミュレーション',
            targetBlank: this.props.targetBlank || false,
            linkType: this.props.linkType || 'Button',
            color: this.props.color || 'Dark',
            buttonStyle: this.props.buttonStyle || 'Standard',
          }}
        />
      </div>
    )
  }
  
}

export default EstimateLink;



// WEBPACK FOOTER //
// ./src/components/estimate-link/index.jsx